import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext.js";
import StatusContext from "./StatusContext.js";
import ClientContext from "./ClientContext.js";
import axios from "axios"

import { config } from '../config.js';
import { sortChats } from './StatusContext.js';


const AIQuizContext = createContext();

export default AIQuizContext;

export const AIQuizProvider = ((props) => {

    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [topic, setTopic] = useState('')
    const [status, setStatus] = useState();
    const [reset, setReset] = useState(false)
  
   
    const {
        currentUser,
        checkCurrentUser,
        checkServerCode, 
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
        setIsLoading,
        mainLanguage,
        changeLanguage,
        ScrollResponseToMiddle,
        setShowLoginDialog,
        handleFocus,
        getAiProvider,
        getAIModel,
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);

   
    const onResetQuiz = () => {
        console.log("OnResetQuiz")
        let a = [...promptsandresponses]

        a.forEach((item)=> 
        {
            item.response.answer[0][1] = false
            item.response.answer[0][2] = false
            item.response.answer[1][1] = false
            item.response.answer[1][2] = false
            item.response.answer[2][1] = false
            item.response.answer[2][2] = false
        })
       
        setPromptsAndResponses(a) 
        setReset(false)   
    }

    const onAcceptAnswer = (prompt, answer) => {
       
        let a = [...promptsandresponses]

        for (let i = 0; i < a.length; ++i)
        {
           if (a[i].id === prompt.id)
           {
                if (prompt.response.answer[0][0] === answer)
                {
                    a[i].response.answer[0][2] = true
                    break;
                }
                else if (prompt.response.answer[1][0] === answer)
                {
                    a[i].response.answer[1][2] = true
                    break;
                }
                else if (prompt.response.answer[2][0] === answer)
                {
                    a[i].response.answer[2][2] = true
                    break;
                }
            }
        }
        updateCredits(25)
        setPromptsAndResponses(a)    
      
    }

    const onResetAnswer = (prompt, answer) => {
       
        let a = [...promptsandresponses]

        for (let i = 0; i < a.length; ++i)
        {
           if (a[i].id === prompt.id)
           {
                if (prompt.response.answer[0][0] === answer)
                {
                    a[i].response.answer[0][1] = false
                    break;
                }
                else if (prompt.response.answer[1][0] === answer)
                {
                    a[i].response.answer[1][1] = false
                    break;
                }
                else if (prompt.response.answer[2][0] === answer)
                {
                    a[i].response.answer[2][1] = false
                    break;
                }
            }
        }
        
        setPromptsAndResponses(a)
    }

    const onSubmitAnswer = (id,response, answer) => {
        
        if (response.answer[0][0] === answer)
        {
            response.answer[0][1] = true; 
        }
        else if (response.answer[1][0] === answer)
        {
            response.answer[1][1] = true;  
        }
         else if (response.answer[2][0] === answer)
         {
            response.answer[2][1] = true;
         }

        let a = [...promptsandresponses]

         for (let i = 0; i < a.length; ++i)
         {
            if (a[i].id === id)
            {
                a[i].response = response;
                break;
            }
         }
        
         setPromptsAndResponses(a)

    }

    
    const onClearChat = () => {
        setPromptsAndResponses([])
        setChatName('')
        setStatus('')
        setChatPrompt('')
    }

    const deleteChat = async (deletionChat) => {
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newchatNames = [];

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/quiz/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return
        }

        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)

        setChatNames([...filteredChats]);
        var templates = JSON.stringify(filteredChats)

        try {

            await axios.post(config.url.API_URL + "/deda_ai_api/quiz/update", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return
        }

        if (chatName === deletionChat.chatname) {
            setChatName('')
            setStatus('')
            setChatPrompt('')
        }
    }

    const displayChat = (displayedChat) => {

        onClearChat();

        //fix prompts ids to match array indexes
        let index = 0;
        displayedChat.promptsandresponses.forEach((item) => {
            item.id = index;
            index++
        })

        setPromptsAndResponses(displayedChat.promptsandresponses)
        setChatName(displayedChat.chatname)
       
        setTopic(displayedChat.topic)

        var deletes = []
        displayedChat.promptsandresponses.forEach((item) => {
            let a = {
                id: item.id,
                state: false
            }
            deletes.push(a)
        })

    }

    const onDeletePrompt = (prompt) => {

        let a = [...promptsandresponses]
 
        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === prompt.id)
            {
                a[i].response.delete = true;
                break
            }
        }
       
        setPromptsAndResponses(a)

    }

    const onCancelDelete = (prompt) => {
        let a = [...promptsandresponses]

        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === prompt.id)
            {
                a[i].response.delete = false;
                break
            }
        }
      
        setPromptsAndResponses(a)
    }

    const onAcceptDelete = (prompt) => {
        let a = promptsandresponses.filter(item => item.id !== prompt.id)

        for ( let i = 0; i < a.length; ++i)
            a[i].id = i

        setPromptsAndResponses(a)
    }

    const onSave = async () => {

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (topic.length === 0 )
        {
            setStatusNavbar(changeLanguage('status', 'notopictosave'))
            return;
        }
        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        setIsLoading(true)

        let q = "/deda_ai_api/quiz/get"

        const res = await axios.post(config.url.API_URL + q, {currentUser}) 
          
        if (res.data.length > 0 )
        {
            //user exists, so update chats
            let newchatNames = [...chatNames];
            let newChat = {}
            let exists = false

            for (let i = 0; i < newchatNames.length; ++i)
            {
                if (newchatNames[i].chatname === chatName)
                    {
                        let result = window.confirm("There is already a quiz with this name. Do you want to overwrite it?");
                        if (!result)
                        {
                            setIsLoading(false)
                            return;
                        }

                        newchatNames[i].topic = topic
                        newchatNames[i].promptsandresponses = promptsandresponses
                        exists = true
                        let templates = JSON.stringify(newchatNames)
                        console.log("Update quiz:", templates)
                                                
                        try{
                             await axios.post(config.url.API_URL + "/deda_ai_api/quiz/update", {currentUser, templates},{
                                     withCredentials:true
                            })
                        }
                        catch (err) {
                            console.log("Update err:", err)
                            setIsLoading(false);
                            return err;
                        }
                        //Update complete
                        setIsLoading(false)         
                        return

                    }
            }

            if (exists)
            {
                //Update existing quiz
                let templates = JSON.stringify(newchatNames)
                console.log("Update quiz:", templates)
                                        
                try{
                     await axios.post(config.url.API_URL + "/deda_ai_api/quiz/update", {currentUser, templates},{
                             withCredentials:true
                    })
                }
                catch (err) {
                    console.log("Update err:", err)
                    setIsLoading(false);
                    return err;
                }
                //Update complete
                setIsLoading(false)         
                return
            }
            else
            {
                //add new quiz
                newChat = {
                    chatname: chatName,
                    topic: topic,
                    promptsandresponses: promptsandresponses 
                }

                newchatNames.push(newChat)
              
                let adjustedChats = sortChats(newchatNames)

                //Update existing chat
                let templates = JSON.stringify(adjustedChats)
                console.log("Update quiz:", templates)
                                        
                try{
                     await axios.post(config.url.API_URL + "/deda_ai_api/quiz/update", {currentUser, templates},{
                             withCredentials:true
                    })
                }
                catch (err) {
                    console.log("Update err:", err)
                    setStatus(`Error: ${checkServerCode(err.code)}`)
                    setIsLoading(false);
                    return err;
                }
                //Update complete
                setChatNames(adjustedChats)
                setIsLoading(false)         
                return

            }
        }
        else // res.data.length === 0
        {
            let newChat = {
                chatname: chatName,
                topic: topic,
                promptsandresponses: promptsandresponses 
            }
            let newchatNames = []

            newchatNames.push(newChat)
            let adjustedChats = sortChats(newchatNames)

            //Update existing quiz
            let templates = JSON.stringify(adjustedChats)
           
            console.log("Update quiz:", templates)
                                    
            try{
                 await axios.post(config.url.API_URL + "/deda_ai_api/quiz/save", {currentUser, templates},{
                         withCredentials:true
                })
            }
            catch (err) {
                console.log("Update err:", err)
                setStatus(`Error: ${checkServerCode(err.code)}`)
                setIsLoading(false);
                return
            }
            //Update complete
            setChatNames(newchatNames)
            setIsLoading(false)         
            return

        }       
}

    
    const onNewQuestions = () => {

        if (checkCurrentUser() === false)
        {
            //setStatus(changeLanguage('status', 'pleaselogin'))
            setShowLoginDialog(true)
            return;
        }

        if (topic.length === 0 )
        {
            setStatus(changeLanguage('status', 'providetopic'))
            return;
        }

        SendQuestionRequest()
    }
    
    async function SendQuestionRequest() {
        //console.log("SendQuestionRequest")
        setStatus("");
        if (checkCurrentUser() === false)
        {
            //setStatus(changeLanguage('status', 'pleaselogin'))
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }
       
        let rqst = "Instructions:" +
        "Answer is a part of a quiz and should consists of one correct answer and two wrong answers." +
        "Provide an extended answer to each question in the following format:" +
        "@@@Correct:<correct answer>" +
        "@@@Wrong: <wrong answer>" +
        "@@@Wrong:<wrong answer>" +
        
        `Topic: ${topic}.` +
        
        "Task:" +
        "Ask me three questions about the topici in" +
        `${mainLanguage}.` + 
        "Start each question with @@@Question:."
        
     
        let s = '';
        promptsandresponses.forEach((item) => {
            s += item.response.question;
        })

        if (s.length > 0)
        {
            rqst += `Do not repeat the following questions: "${s}"`;
        }
        
        let req = {
            user: currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: getAiProvider(),
            aimodel: getAIModel(),
        }

        setIsLoading(true);

        for (let j = 1; j <= 3; j++)
        {
            try {
               
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                    withCredentials: true
                })

                let server_response = JSON.parse(res.data);
            
                let tokens = server_response.data.split("@@@"); // Split
                //console.log('Tokens:', tokens)

                let quiz = []
                let question =''
                let correct =  ''
                let wrong_1 = ''
                let wrong_2 = ''

                for (let i = 0; i < tokens.length; i++) 
                {
                
                    
                    let parts = tokens[i].split(": ");
                    if (parts.length === 2)
                    {
                        if (parts[0] === "Question") {
                            question = parts[1].trim();
                        }
                        if (parts[0] === "Correct") {
                            correct = parts[1].trim();
                        }
                        if (parts[0] === "Wrong" && wrong_1 ==='' ) {
                            wrong_1 = parts[1].trim();
                        }
                        else if (parts[0] === "Wrong" && wrong_1 !=='' ) {
                            wrong_2 = parts[1].trim();
                        }
                

                        if (question !== '' && correct !== '' && wrong_1 !== '' && wrong_2 !== '')
                        {
                        
                            const randomNumber = Math.floor(Math.random() * 3); // generates a random number between 0 and 2 inclusive

                            let a = {}
                            if (randomNumber === 0)
                            {
                                a = {
                                    id: i,
                                    delete:false,
                                    question: question,
                                    answer: [[correct, false, false, true], [wrong_1, false, false, false], [wrong_2, false, false, false]]
                                }

                            }
                            else if (randomNumber === 1)
                            {
                                a = {
                                    id: i,
                                    delete: false,
                                    question: question,
                                    answer: [[wrong_1, false, false, false], [correct, false, false, true], [wrong_2, false, false, false]]
                                }
                            }
                            else if (randomNumber === 2)
                            {
                                a = {
                                    id: i,
                                    delete: false,
                                    question: question,
                                    answer: [[wrong_2, false, false, false],  [wrong_1, false, false, false], [correct, false, false, true],]
                                }
                            }
                            quiz.push(a)
                            
                            question = ''
                            correct = ''
                            wrong_1 = ''
                            wrong_2 = ''
                        
                        }
                    }
                }
                        
                if (quiz.length === 0)
                {   
                    if ( j < 3)
                    {
                        continue;
                    }
                    else {
                        //setStatus("Something went wrong. Please try again.");
                        setStatus(changeLanguage('quiz', 'somethingwrong'))
                        setIsLoading(false);
                        return;
                    }
                }
                    
                let id = 0
                if (promptsandresponses.length) 
                    id = promptsandresponses[promptsandresponses.length - 1].id + 1

                let a = []
            
                for ( let i = 0; i < quiz.length; i++)
                {
                    let r = {
                        id: id,
                        prompt: quiz[i].question,
                        response: quiz[i],
                    }
                    a.push(r)
                    id++;
                    
                }
              
                setPromptsAndResponses([...promptsandresponses, ...a])
                setStatus("");
            
                ScrollResponseToMiddle()
                handleFocus()
                
                updateCredits(server_response.tokens)

                break


            } catch (err) {
                setStatus(`Error: ${checkServerCode(err.response.data)}`)
                setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
                break
            }
        }
        setIsLoading(false);
    }

    return <AIQuizContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse,
        promptsandresponses,
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onClearChat,
        onSave,
        deleteChat,
        displayChat,
        onDeletePrompt,
        onCancelDelete,
        onAcceptDelete,
        topic,
        setTopic,
        onNewQuestions,
        status,
        onSubmitAnswer,
        onAcceptAnswer,
        onResetAnswer,
        onResetQuiz,
        reset,
        setReset,
    }}>
        {props.children}
    </AIQuizContext.Provider>
})